// WebSocket configuration
// Connect directly to the backend WebSocket endpoint
// export const WS_BASE_URL = '/ws';
export const WS_BASE_URL = 'http://localhost:8084/ws';

// STOMP topics for real-time updates
export const WS_TOPICS = {
  // Topic for market updates by event ID
  MARKET_UPDATES: (eventId: number) => `/topic/markets/${eventId}`,
  
  // Topic for event updates
  EVENT_UPDATES: (eventId: number) => `/topic/events/${eventId}`,
  
  // Topic for all markets updates (admin broadcast)
  ALL_MARKETS: '/topic/markets/all',
  
  // Topic for all events updates (admin broadcast)
  ALL_EVENTS: '/topic/events/all'
};

// STOMP endpoints for sending commands
export const WS_ENDPOINTS = {
  // Endpoint for sending market commands
  MARKET_COMMANDS: '/app/markets',
  
  // Endpoint for sending event commands
  EVENT_COMMANDS: '/app/events'
};
